(() => {
  if (window.ltCookiePreferencesReady) return;
  window.ltCookiePreferencesReady = true;
  let bannerReady;
  const getBanner = () => {
    if (window.privacyBanner?.showPreferences) return Promise.resolve(window.privacyBanner);
    if (bannerReady) return bannerReady;
    bannerReady = new Promise((resolve, reject) => {
      let script = document.querySelector('script[src*="privacy-banner/storefront-banner.js"]');
      const finish = () => window.privacyBanner?.showPreferences
        ? resolve(window.privacyBanner) : reject(new Error('Privacy banner unavailable'));
      const timeout = setTimeout(() => { bannerReady = undefined; reject(new Error('Privacy banner timeout')); }, 10000);
      const loaded = () => { clearTimeout(timeout); finish(); };
      if (!script) {
        script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
        script.addEventListener('load', loaded, { once: true });
        script.addEventListener('error', () => { clearTimeout(timeout); bannerReady = undefined; reject(new Error('Privacy banner load failed')); }, { once: true });
        document.head.append(script);
      } else {
        script.addEventListener('load', loaded, { once: true });
      }
    });
    return bannerReady;
  };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-lt-cookie-preferences]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-lt-cookie-status]');
    status.textContent = '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const banner = await getBanner();
      await banner.showPreferences();
    } catch {
      status.textContent = 'Preferințele nu se pot încărca momentan. Reîncărcați pagina și încercați din nou.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
